import 'zone.js';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { TranslateService } from './app/core/services/translate.service';
import { AmplitudeService } from './app/core/services/amplitude.service';
import { FirebaseInitService } from './app/core/services/firebase-init.service';
import { configureLocales } from './app/core/config/locale.config';

configureLocales();

bootstrapApplication(App, appConfig)
  .then((appRef) => {
    // Initialize services after app bootstrap
    const translateService = appRef.injector.get(TranslateService);
    const amplitudeService = appRef.injector.get(AmplitudeService);
    const firebaseInitService = appRef.injector.get(FirebaseInitService);
    
    // Initialize Firebase
    firebaseInitService.init();
    
    // Initialize translations
    translateService.initializeTranslations().then(() => {
      // Then initialize Amplitude
      amplitudeService.init();
    });
  })
  .catch((err) => console.error(err));
